import { Component, inject, ChangeDetectionStrategy, signal } from '@angular/core';
import { FormGroup, FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { finalize } from 'rxjs';
import { Auth } from '../../../services/auth';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-forgot-password',
  imports: [
    ReactiveFormsModule,
    MatDialogModule,
    MatButtonModule,
    MatInputModule,
    MatIconModule,
    MatProgressSpinnerModule,
  ],
  templateUrl: './forgot-password.html',
  styleUrl: './forgot-password.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ForgotPassword {
  private dialogRef = inject(MatDialogRef<ForgotPassword>);
  private authService = inject(Auth);
  private toastr = inject(ToastrService);
  isLoading = signal(false);
  forgotPasswordForm = new FormGroup({
    usernameOrEmail: new FormControl('', [Validators.required])
  });

  onSubmit() {
    if (this.isLoading()) return;
    if (this.forgotPasswordForm.valid) {
      const value = this.forgotPasswordForm.value.usernameOrEmail!;

      this.isLoading.set(true);
      this.authService.requestPasswordReset(value)
        .pipe(finalize(() => this.isLoading.set(false)))
        .subscribe({
          next: () => {
            this.toastr.success('Jelszó visszaállítási email küldve!', 'Sikeres művelet');
            this.dialogRef.close();
          },
          error: (error) => {
            this.toastr.error(error.error?.message || 'Hiba történt az igénylés során!', 'Hiba');
          }
        });
    }
  }

  onClose() {
    this.dialogRef.close();
  }
}
